import { computed } from 'vue'
import type { RouteRecordRaw } from 'vue-router'

import { registerRelabelProgressConsumer } from '../composables/useLabellingProgressStream'
import { creativeAiSettingsNavEntry } from '../nav.settings'
import { creativeAiSettingsRoutes } from '../routes.settings'
import { useLabelSchemaStore } from '../stores/labelSchemaStore'

import type { SettingsNavEntry } from '@/features/workspace-settings'

export interface CreativeAiSettingsRegistrar {
  registerNav: (entry: SettingsNavEntry) => void
  registerRoutes: (records: RouteRecordRaw[]) => void
}

export function installCreativeAiSettings(registrar: CreativeAiSettingsRegistrar): void {
  registrar.registerRoutes(creativeAiSettingsRoutes)
  registrar.registerNav(creativeAiSettingsNavEntry)

  const store = useLabelSchemaStore()
  registerRelabelProgressConsumer({
    active: computed(() => store.hasActiveRun),
    applyProgress: store.applyRelabelProgress,
    reload: store.reloadRun,
    reset: store.resetState,
  })
}
